import { render, staticRenderFns } from "./GiftCertificatesDashboard.vue?vue&type=template&id=699fbf52"
import script from "./GiftCertificatesDashboard.vue?vue&type=script&lang=js"
export * from "./GiftCertificatesDashboard.vue?vue&type=script&lang=js"
import style0 from "./GiftCertificatesDashboard.vue?vue&type=style&index=0&id=699fbf52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports